var map = {
	"./Points_being_collected.gif": 327,
	"./Points_being_collected_pld.gif": 486,
	"./background.gif": 135,
	"./misile.gif": 487,
	"./movingFullStone.gif": 328,
	"./stamp_2x.gif": 329,
	"./stamp_5x.gif": 330,
	"./war_day_bg.gif": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 566;